
/* eslint-disable react/prop-types */
import { Container, Grid, Stack, Typography, styled } from "@mui/material";
import AppSection from "../../components/AppSection";
import CardAds from "../../components/CardAds";
import { GoogleBannerAds, GoogleGridAds } from "../../components/GoogleAds";
import useLocales from "../../hooks/useLocales";
import useResponsive from "../../hooks/useResponsive";
import useSettings from "../../hooks/useSettings";
import MenuSection from "./MenuSection";
import VideoSection from "./VideoSection";
import Welcome from "./Welcome";

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
  },
}));

export function StreetExamSection({ nextItem, prevItem, currentItem, streetExams }) {
  const { themeStretch } = useSettings();
  const isDesktop = useResponsive('up', 'md');
  const { translate } = useLocales();

  return (
    <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
      <RootStyle>
        <Banner />
        <Grid container my={5}>
          <Grid item xs={12} md={12} justifyContent={"center"}>
            <Typography variant={'h2'} textAlign={"center"} textTransform={"capitalize"}>
              {translate('streetExam.title')}
            </Typography>
          </Grid>
        </Grid>
        <Grid container my={3} >
          <Grid item xs={12} md={2.5}>
            <MenuSection streetExams={streetExams} />
            {isDesktop && <Stack p={1} spacing={2}>
              <AppSection />
              <GoogleBannerAds />
              <GoogleBannerAds />
            </Stack>}
          </Grid>
          <Grid item xs={12} md={9.5}>
            <VideoSection currentItem={currentItem} prevItem={prevItem} nextItem={nextItem} />
          </Grid>
          <Grid item xs={12} md={12}>
            <GoogleGridAds />
          </Grid>
        </Grid>
      </RootStyle>
    </Container>);
}

function Banner() {
  return (<Grid container spacing={3} mb={5}>
    <Grid item xs={12} md={8}>
      <Welcome />
    </Grid>
    <Grid item xs={12} md={4}>
      <CardAds />
    </Grid>
  </Grid>);
}
